import { withCurrency } from '@/utils';
import { Button, Popup } from 'antd-mobile';
import { ProductOptions } from '@/pages/result/variants/options';
import { getSelectSKU } from '@/services/newProduct';
import './index.scss';

const ProductDetail = (props: any) => {
  const {
    type = 1,
    cover,
    addToCart,
    visible,
    setVisible,
    selectedVariant,
    productOptions,
    setSelectedVariant,
    current,
    num,
    setNum
  } = props.data;
  return (
    <Popup
      visible={visible}
      bodyStyle={{ height: '75vh' }}
      showCloseButton={true}
      onMaskClick={() => {
        setVisible(false);
      }}
      onClose={() => {
        setVisible(false);
      }}
      style={{
        '--z-index': '1001'
      }}
    >
      <div className='hho_popup_buy'>
        <div className='popup-top'>
          <div className='top-main'>
            <div className='left-cover'>
              <img src={cover || selectedVariant?.imageUrl} />
            </div>
            <div className='center-price'>
              <div className=''>
                <span className='price'>{withCurrency(selectedVariant?.price)}</span>円(税込)
              </div>
            </div>
          </div>
          <div className='top-ensure'>
            <div className='left-text'>
              <i className='iconfont icon-icon_hhosafe_fill' />
              サービス保証
            </div>
            <div className='right-text'>7日間返品可能・安全安心な決済方法</div>
          </div>
        </div>
        <div className='popup-center'>
          {productOptions ? (
            <ProductOptions
              selectedVariant={selectedVariant}
              skuList={current?.skuList}
              productOptions={productOptions}
              // type={type}
              onClick={(optionList: string[]) => {
                let obj = getSelectSKU(optionList, current?.skuList);
                setSelectedVariant({ ...obj });
              }}
            />
          ) : null}
          {current?.supplementaryNotes ? (
            <img className='custom-notes' src={current?.supplementaryNotes} />
          ) : null}

          <div className='hho-variant-sku-quantity-input-wrapper'>
            <div className='hho-quantity-title'>購入数量</div>
            <div className='quantity-operation-wrapper'>
              <span
                className='operate-btn'
                onContextMenu={(e) => {
                  e.preventDefault();
                }}
                onClick={() => {
                  setNum(Math.max(num - 1, 1));
                }}
              >
                —
              </span>
              <span className='num'>{num}</span>
              <span
                className='operate-btn add'
                onContextMenu={(e) => {
                  e.preventDefault();
                }}
                onClick={() => {
                  // 数量加1
                  setNum(num + 1);
                }}
              >
                <span className='add-icon'>+</span>
              </span>
            </div>
          </div>
        </div>

        <div className='popup-bottom'>
          <div className='bottom-btn'>
            <Button
              className='cart-btn'
              onClick={() => {
                setVisible(false);
                addToCart();
              }}
            >
              {type === 1 ? (
                ' 今すぐ購入'
              ) : (
                <>
                  <i className='iconfont icon-icon_addcart'></i>カートに入れる
                </>
              )}
            </Button>
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default ProductDetail;
